module.exports = __webpack_public_path__ + "ddc99a3eeb06884857ba8edf89928eb1.pdf";